import { useEffect, useState } from "react";

import { Loading } from "../shared/components/Loading";
import { Tabs } from "../shared/components/Tabs";
import { Title } from "../shared/components/Title";

import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";

import { EnvironmentsAPI } from "../providers/EnvironmentsAPI";

import BannersClub from "../shared/containers/Banners/BannersClub";
import BannersDelivery from "../shared/containers/Banners/BannersDelivery";
import BannersTotem from "../shared/containers/Banners/BannersTotem";

import ROLES from "data/Roles";
import { UserStorage } from "shared/tools/UserStorage";
import { Button } from "../shared/components/Button";
import { Icon } from "../shared/components/core/Icon";
import styles from "../styles/banners.module.scss";

const BannersTabs = {
  // HOME: {
  //   key: "HOME",
  //   name: "Home",
  // },
  DELIVERY: {
    key: "DELIVERY",
    name: "Delivery",
  },
  TOTEM: {
    key: "TOTEM",
    name: "Totem",
  },
  CLUB: {
    key: "CLUB",
    name: "Modo Clube",
  },
};

export default function Banners() {
  const [activeTab, setActiveTab] = useState(BannersTabs.DELIVERY.key);
  const [environment, setEnvironment] = useState({});
  const [bannersHome, setBannersHome] = useState([]);
  const [bannersDelivery, setBannersDelivery] = useState([]);
  const [bannersClub, setBannersClub] = useState([]);
  const [bannersTotem, setBannersTotem] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openSort, setOpenSort] = useState(false);

  useEffect(() => {
    setEnvironment(EnvironmentStorage.getEnvironment());
    loadBanners();
  }, []);

  const loadBanners = async () => {
    setLoading(true);

    const environment = await EnvironmentStorage.getEnvironment();
    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
    const isCiaTC = holdingId === 811;

    const banners = await EnvironmentsAPI.getConfigurationsByAlias(
      isCiaTC ? holdingId : environment?.id,
      "banners"
    );

    setLoading(false);

    // setBannersHome(banners?.home || { desktop: [], mobile: [] });
    setBannersDelivery(banners?.delivery || { desktop: [], mobile: [] });
    setBannersClub(banners?.club || { desktop: [], mobile: [] });
    setBannersTotem(banners?.totem || { vertical: [], horizontal: [] });
  };

  const getSubtitle = () => {
    if (environment?.brand)
      return (
        `${environment.brand.name} - ${environment.name}` +
        (environment.active === false ? " (Inativa)" : "")
      );
    return environment?.name;
  };

  const isClubMode = environment?.holdingId === 1272;
  const isSupport = UserStorage.getLoggedUser()?.role === ROLES.SUPPORT;

  return (
    <div className={styles.bannersPage}>
      <Title
        title="Banners"
        subtitle={getSubtitle()}
        backTo={{ url: "/configuracoes", name: "Configurações" }}
      >
        <Button design="default-icon" onClick={() => setOpenSort(true)}>
          <Icon name="sort-size-up" size="lg" />
        </Button>
      </Title>

      <Tabs
        tabs={Object.values(BannersTabs).filter((b) =>
          isClubMode || isSupport ? b : b.key !== "CLUB"
        )}
        activeTab={activeTab}
        onTabSelected={(tab) => setActiveTab(tab)}
      />

      {loading ? (
        <div className={styles.loading}>
          <Loading />
        </div>
      ) : (
        <>
          {activeTab === BannersTabs.DELIVERY.key && (
            <BannersDelivery
              banners={bannersDelivery}
              openSort={openSort}
              onCloseSort={() => setOpenSort(false)}
              onRefresh={() => loadBanners()}
            />
          )}

          {activeTab === BannersTabs.CLUB.key && (
            <BannersClub
              banners={bannersClub}
              openSort={openSort}
              onCloseSort={() => setOpenSort(false)}
              onRefresh={() => loadBanners()}
            />
          )}

          {activeTab === BannersTabs.TOTEM.key && (
            <BannersTotem
              banners={bannersTotem}
              openSort={openSort}
              onCloseSort={() => setOpenSort(false)}
              onRefresh={() => loadBanners()}
            />
          )}
        </>
      )}
    </div>
  );
}
